import ky from "ky-universal";
export function ddxFaa() {
	// Grab all text input fields
	let faaFirmId;
	const formAllFields = document.querySelectorAll(
		'.ddx-faa-form input[type="text"], .ddx-faa-form input[type="email"], .ddx-faa-form input[type="tel"], .ddx-faa-form textarea, #faa-contact-form input[type="text"]'
	);

	if (formAllFields.length) {
		// On load move labels above input field
		formAllFields.forEach((field) => {
			const fieldValue = field.value;
			if (fieldValue) {
				field.parentNode
					.querySelector("label")
					.animate(
						{ top: "-1.1875rem", fontSize: "0.8rem" },
						{ duration: 200, iterations: 1, fill: "forwards" }
					);
			} else {
				field.parentNode
					.querySelector("label")
					.animate(
						{ top: "-0.5rem", fontSize: "1.25rem" },
						{ duration: 200, iterations: 1, fill: "forwards" }
					);
			}
		});

		// On focus on any field change position of label
		formAllFields.forEach((field) => {
			field.addEventListener("focus", () => {
				field.parentNode
					.querySelector("label")
					.animate(
						{ top: "-1.1875rem", fontSize: "0.8rem" },
						{ duration: 200, iterations: 1, fill: "forwards" }
					);
				field.parentNode.classList.add("currentactive");
			});
		});

		// On blur change position of label
		formAllFields.forEach((field) => {
			field.addEventListener("blur", () => {
				const fieldValue = field.value;
				if (fieldValue.length <= 0) {
					field.parentNode
						.querySelector("label")
						.animate(
							{ top: "-0.5rem", fontSize: "1.25rem" },
							{ duration: 200, iterations: 1, fill: "forwards" }
						);
				}
				field.parentNode.classList.remove("currentactive");
			});
		});

		// On change event for all fields to prevent page refreshes
		formAllFields.forEach((field) => {
			field.addEventListener("change", () => {
				const fieldValue = field.value;
				if (fieldValue.length === 0) {
					field.parentNode
						.querySelector("label")
						.animate(
							{ top: "-0.5rem", fontSize: "1.25rem" },
							{ duration: 200, iterations: 1, fill: "forwards" }
						);
				} else {
					field.parentNode
						.querySelector("label")
						.animate(
							{ top: "-1.1875rem", fontSize: "0.8rem" },
							{ duration: 200, iterations: 1, fill: "forwards" }
						);
				}
			});
		});
	}

	const ddxRadioButtons = document.querySelectorAll("input[name='ddx-faa-group']");
	if (ddxRadioButtons.length) {
		ddxRadioButtons.forEach((radioButton) => {
			radioButton.addEventListener("click", () => {
				if (radioButton.checked) {
					const ddxFaaForm = ddxRadioButtons[0].closest("form");
					if (ddxFaaForm) {
						// if Australia page, toggle zip input for Australia / select region for NZ
						const regionSelector = ddxFaaForm.querySelector("select[name='ddx-faa-region']");
						if (regionSelector) {
							const zipWrapper = ddxFaaForm.querySelector(".ddx-faa-zipcode-input");
							const zipInput = zipWrapper.querySelector("input[name='ddx-zip']");
							if (radioButton.value === "AU") {
								regionSelector.classList.add("ddx-faa-hide-field");
								zipWrapper.classList.remove("ddx-faa-hide-field");
								regionSelector.value = "";
								zipInput.value = "";
							} else if (radioButton.value === "NZ") {
								regionSelector.classList.remove("ddx-faa-hide-field");
								zipWrapper.classList.add("ddx-faa-hide-field");
								zipInput.value = "";
							}
						}
						ddxFaaForm
							.querySelectorAll("input[name='ddx-faa-group']")
							.forEach((radio) => radio.classList.remove("incomplete"));
					}
				}
			});
		});
	}

	if (document.querySelector(".permission-checkbox")) {
		document.querySelectorAll(".permission-checkbox").forEach((checkbox) => {
			const faaContactFormModal = document.querySelector("#faa-contact-form-dialog");
			const closeButton = faaContactFormModal.querySelector(".mfp-close");
			const checkboxButton = checkbox.querySelector("input");

			const handleDialogClose = (event) => {
				const form = faaContactFormModal.querySelector("#faa-contact-form");

				if (!form.contains(event.target)) {
					checkboxButton.checked = false;
					faaContactFormModal.close();
				}

				faaContactFormModal.removeEventListener("click", handleDialogClose);
			};

			const handleEscKey = (event) => {
				if (event.key === "Escape" || event.key === "Esc") {
					checkboxButton.checked = false;
					faaContactFormModal.close();
				}

				window.removeEventListener("keydown", handleEscKey);
			};

			checkbox.addEventListener("click", (event) => {
				event.preventDefault();

				checkboxButton.checked = true;
				faaFirmId = checkboxButton.getAttribute("data-rid");
				faaContactFormModal.addEventListener("click", handleDialogClose);

				closeButton.addEventListener(
					"click",
					(event) => {
						event.stopPropagation();
						checkboxButton.checked = false;
						faaContactFormModal.close();
					},
					{ once: true }
				);

				window.addEventListener("keydown", handleEscKey);

				faaContactFormModal.showModal();
			});
		});
	}

	// form button on click to popup terms/recaptcha
	const ddxFaaFormBtn = document.querySelector("button[name='ddx-faa-form-btn']");
	if (ddxFaaFormBtn) {
		ddxFaaFormBtn.addEventListener("click", async (e) => {
			e.preventDefault();
			let errors = 1;
			const ddxFaaForm = ddxFaaFormBtn.closest("form");
			let url = "/maps-api/geocode?";
			errors = faaValidate(ddxFaaForm);
			let region, country, NZRegion, postalZip;

			if (errors === 0) {
				if (ddxFaaForm.querySelector("input[name='ddx-zip']")) {
					postalZip = ddxFaaForm.querySelector("input[name='ddx-zip']").value;
				}
				if (ddxFaaForm.querySelector("select[name='ddx-faa-region']")) {
					region = ddxFaaForm.querySelector("input[name='ddx-faa-group']:checked").value;
				} else if (ddxFaaForm.querySelector("[name='ddx-country']")) {
					region = ddxFaaForm.querySelector("[name='ddx-country']").value;
				} else {
					region = "US";
				}

				switch (region) {
					case "US":
						country = "USA";
						break;
					case "AU":
						country = "Australia";
						break;
					case "NZ":
						country = "New+Zealand";
						break;
					default:
						country = "USA";
				}

				if (region === "NZ") {
					const ddxFaaFormRegionDropdown = document.querySelector("select[name='ddx-faa-region']");
					if (ddxFaaFormRegionDropdown) {
						NZRegion = ddxFaaFormRegionDropdown.value;
					}
					url =
						url +
						"address=" +
						NZRegion +
						"+" +
						country +
						"&region=" +
						region +
						"&components=country:" +
						region;
				} else {
					url =
						url +
						"address=Postcode+" +
						postalZip +
						"+" +
						country +
						"&region=" +
						region +
						"&components=country:" +
						region;
				}
			}

			try {
				const response = await ky.get(url);
				const data = await response.json();
				if (data.status === "OK") {
					const zipValue = ddxFaaForm.querySelector("input[name='ddx-zip']");
					if (
						data.results[0].formatted_address === "New Zealand" ||
						data.results[0].formatted_address === "Australia" ||
						data.results[0].formatted_address === "United States"
					) {
						if (!zipValue.classList.contains("incomplete")) {
							zipValue.value = "";
							zipValue.classList.add("incomplete");
						}
					} else {
						zipValue.classList.remove("incomplete");
						ddxFaaForm.querySelector("input[name='ddx-lat']").value =
							data.results[0].geometry.location.lat;
						ddxFaaForm.querySelector("input[name='ddx-lng']").value =
							data.results[0].geometry.location.lng;

						const ddxFaaFormModal = document.querySelector("#ddx-faa-legal-popup-dialog");
						const closeButton = ddxFaaFormModal.querySelector(".mfp-close");

						const handleClose = (event) => {
							const form = ddxFaaFormModal.querySelector("#ddx-faa-legal-popup");

							if (!form.contains(event.target)) {
								if (zipValue) zipValue.value = "";
								ddxFaaFormModal.close();
							}

							ddxFaaFormModal.removeEventListener("click", handleClose);
						};

						closeButton.addEventListener(
							"click",
							(event) => {
								event.stopPropagation();
								ddxFaaFormModal.close();
							},
							{ once: true }
						);

						ddxFaaFormModal.addEventListener("click", handleClose);
						ddxFaaFormModal.show();
					}
				} else {
					if (country === "NZ") {
						ddxFaaForm.querySelector("select[name='ddx-faa-region']").classList.add("incomplete");
					} else {
						const zipValue = ddxFaaForm.querySelector("input[name='ddx-zip']");
						if (zipValue) {
							zipValue.value = "";
							zipValue.classList.add("incomplete");
						}
					}
				}
			} catch (error) {
				console.error({
					status: error.response.status,
					response: error.response.statusText,
					url
				});
			}
		});
	}
	const zipField = document.querySelector("input[name='ddx-zip']");
	if (zipField) {
		zipField.addEventListener("change", (e) => {
			if (e.target.value.trim().length) {
				e.target.classList.remove("incomplete");
			}
		});
	}

	const mandatoryInputs = document.querySelectorAll("input.mandatory");
	if (mandatoryInputs.length) {
		mandatoryInputs.forEach((input) => {
			input.addEventListener("change", () => {
				input.classList.remove("incomplete");
			});
		});
	}

	const faaContactFormBtn = document.querySelector("#faa-contact-btn");
	if (faaContactFormBtn) {
		faaContactFormBtn.addEventListener("click", (e) => {
			e.preventDefault();
			const rid = faaFirmId;
			saveContactForm(rid);
		});
	}
}

const faaValidate = (form) => {
	let errors = 0;
	const radioBtnGroup = form.querySelectorAll("input[name='ddx-faa-group']");
	const zipField = form.querySelector("[name='ddx-zip']");
	const regionSelectGroup = form.querySelector("select[name='ddx-faa-region']");

	// if initial form and page is australia [au-en]
	if (regionSelectGroup) {
		// neither AU or NZ radio button has NOT been selected
		const countrySelected = form.querySelector("input[name='ddx-faa-group']:checked");
		if (!countrySelected) {
			errors++;
			radioBtnGroup.forEach((radio) => radio.classList.add("incomplete"));
		}
		if (countrySelected && countrySelected.value === "AU") {
			// if AU radio button checked and ZIP not filled out
			if (zipField.value === "") {
				errors++;
				zipField.classList.add("incomplete");
			}
		}
		if (countrySelected && countrySelected.value === "NZ") {
			// if NZ radio button checked and NO region selected
			if (regionSelectGroup.value === "") {
				errors++;
				regionSelectGroup.classList.add("incomplete");
			}
		}
	} else if (document.querySelector("input[data-field='name']")) {
		const contactFormName = document.querySelector("input[data-field='name']");
		const contactFormEmail = document.querySelector("input[data-field='email']");
		if (contactFormName.value === "") {
			errors++;
			contactFormName.classList.add("incomplete");
		}
		if (contactFormEmail && contactFormEmail.value === "") {
			errors++;
			contactFormEmail.classList.add("incomplete");
		}
		if (contactFormEmail && !checkEmail(contactFormEmail.value)) {
			errors++;
			contactFormEmail.classList.add("incomplete");
		}
	} else {
		// initial form and page is US and no radio button has been selected
		if (!form.querySelector("input[name='ddx-faa-group']:checked")) {
			errors++;
			radioBtnGroup.forEach((radio) => radio.classList.add("incomplete"));
		}

		if (zipField.value === "") {
			errors++;
			zipField.classList.add("incomplete");
		}
	}
	return errors;
};

const checkEmail = (val) => {
	var emailRe =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRe.test(val);
};

const saveContactForm = (id) => {
	const contactForm = document.querySelector("#faa-contact-form");
	if (contactForm) {
		const form = contactForm.querySelector(".faa-form");
		if (form) {
			const errors = faaValidate(form);
			if (errors === 0) {
				const contactFormName = form.querySelector("input[data-field='name']").value;
				const contactFormEmail = form.querySelector("input[data-field='email']").value;
				updateContactStatus(id, contactFormName, contactFormEmail);
			}
		}
	}
};

const updateContactStatus = (id, contactFormName, contactFormEmail) => {
	const dataObj = {};
	dataObj.id = id;
	dataObj.name = contactFormName;
	dataObj.email = contactFormEmail;
	dataObj.requested_contact = true;

	sendPatch(id, dataObj);
};

const sendPatch = async (id, dataObj) => {
	// value of faaBase will be coming from cshtml
	// eslint-disable-next-line no-undef
	const matchURL = faaBase + "/investor/match/" + id + "/";

	// Fingerprint will be coming from cshtml
	// eslint-disable-next-line no-undef
	dataObj.fingerprint = new Fingerprint().get().toString();

	const response = await ky.patch(matchURL, {
		headers: new Headers({
			"Content-Type": "application/json"
		}),
		body: JSON.stringify(dataObj)
	});

	if (response.ok) document.getElementById("faa-contact-form-dialog").close();
};
